// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"362": "LazyIdentificationForm","616": "LazyGoogleOneTap",}[chunkId] + "." + {"362": "358fd4b4b26f30ac","616": "2c4c96c6aa91b94b",}[chunkId] + ".js"
}